import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';
import { ApiResponse } from '../models/api-response';

@Injectable()
export class ColumnService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }

  public getColumns(user_Id: any, page: string): Promise<any> {
    const headers = {
      'Content-Type': 'application/json',
    };
    return new Promise((resolve, reject) => {
      this.http.get<any>(environment.apiUrl + 'column/get?UserId=' + user_Id + '&Page=' + page).subscribe(data => {
        resolve(data);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

  public save(user: any, page: string, columns: any): Promise<ApiResponse> {
    const headers = {
      'Content-Type': 'application/json',
    };

    var dto = {
      user_Id: user,
      page: page,
      columns: columns,
    };

    return new Promise((resolve, reject) => {
      this.http.post<ApiResponse>(environment.apiUrl + 'column/post', dto, { headers: headers }).subscribe(data => {
        resolve(data);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

}
